import { camelCase } from "lodash-es";

/**
 *
 * @param title
 * @param keySuffix
 * @param valueSuffix
 * @returns {{rowDataAid: *, valueDataAid: string, title: {dataAid: string, text:title}}}
 */
const getRowObject = ({title, titleDataAid = 'key', valueSuffix = 'value'}) => ({
    rowDataAid: camelCase(title),
    title: {
        text: title,
        dataAid: titleDataAid,
    },
    valueDataAid: valueSuffix,
});



const BANK_DETAIL_CARD = {
    cardDataAid: 'bankDetails',
    statusLabelDataAid: 'label',
    primaryTag: {
        dataAid: 'label'
    },
    description: {
        bankNameDataAid: "title",
        bankBranchDataAid: 'subtitle'
    },
    accountNumberRow: {
        ...getRowObject({title:"Account number"})
    },
    ifscRow: {
       ...getRowObject({title:'IFSC'})
    },
    accountTypeRow: {
        ...getRowObject({title:"Account type"})
    }
}

const getMandateListItemDetailObject = ({ text = undefined, idSuffix= undefined }) => ({
    dataAid: camelCase(text + idSuffix),
    text,
});

const MANDATE_DETAIL_CARD = {
    title: {
        dataAid: "mandateDetails", // Needs to be changed in design, add comment
        text: "Mandate details"
    },
    rowDataAid: (idx) => `mandateRow${idx}`,
    idKey: getMandateListItemDetailObject({ text: "ID", idSuffix: "key" }),
    mandateLimitKey: getMandateListItemDetailObject({text:"Mandate limit", idSuffix:"key"}),
    idValue: getMandateListItemDetailObject({ idSuffix: "value" }),
    statusKey: getMandateListItemDetailObject({ text: "Status", idSuffix: "key" }),
    statusValue: {
        dataAid: "mandate",
        // Exceptional case, dataAid is set for the "Status" component not for internal Typography and Icon
        // text comes from API
    },

}

const MISCELLANEOUS = {
    screenDataAid: 'mandateDetailStatus',
    pageTitle: {
        text: 'Banks & mandates',
        dataAid: 'bankMandates'
    },
    footerInfoCard: {
        text: 'Bank verification has failed. Verify your bank account again',
        dataAid: "verificationMessage"
    },
    footerBtnVerify: {
        text: 'Verify bank',
        dataAid: "primary"
    },
    footerBtnUploadDocs: {
        text: 'Reupload document',
        dataAid: "primary"
    }
}


const BANK_AND_MANDATE_DETAIL = {
    BANK_DETAIL_CARD,
    MANDATE_DETAIL_CARD,
    ...MISCELLANEOUS
}

export default  BANK_AND_MANDATE_DETAIL
